// extracted by mini-css-extract-plugin
module.exports = {"titleContainerOpened":"desktop_titleContainerOpened__FQI4J","title":"desktop_title__JuIoA","titleOpened":"desktop_titleOpened__L8cAE"};